// eslint-disable-next-line complexity
const deserializePractitioner = (api = {}) => {
  const safeSplit = value => (typeof value === 'string' && value.trim() !== '' ? value.split(',').map(v => v.trim()) : []);

  return {
    alignerPrice: {
      adult: api.aligner_semester_price ? Number(api.aligner_semester_price) : undefined
    },

    alignerSupplier: {
      enabled: !!api.aligner_supplier,
      name: safeSplit(api.aligner_supplier)
    },

    avgAppointmentDelay: api.avg_days_to_first_appointment ?? undefined,

    ceramicCrownPrice: {
      min: api.crown_ceramic_min_price ? Number(api.crown_ceramic_min_price) : 0,
      max: api.crown_ceramic_max_price ? Number(api.crown_ceramic_max_price) : 0
    },

    cerecCFAO: api.uses_cerec_cfao || false,

    firstName: api.first_name || '',
    lastName: api.last_name || '',

    gender: api.gender === 'F' ? 'female' : 'male',

    implantPrice: {
      min: api.implant_min_price ? Number(api.implant_min_price) : 0,
      max: api.implant_max_price ? Number(api.implant_max_price) : 0
    },

    implantSupplier: {
      enabled: !!api.implant_supplier,
      name: safeSplit(api.implant_supplier)
    },

    opticalImpression: api.uses_optical_impression || false,

    orthoLabSupplier: {
      enabled: !!api.ortho_lab_supplier,
      name: safeSplit(api.ortho_lab_supplier)
    },

    orthoPrice: {
      child: api.ortho_semester_child_price ? Number(api.ortho_semester_child_price) : undefined,
      adult: api.ortho_semester_adult_price ? Number(api.ortho_semester_adult_price) : undefined
    },

    prosthesisSupplier: {
      enabled: !!api.prosthesis_supplier,
      name: safeSplit(api.prosthesis_supplier)
    },

    specialties: {
      omniPractice: api.is_general_practice || false,
      implantology: api.is_implantology || false,
      orthodontics: api.is_orthodontics || false,
      periodontology: api.is_periodontics || false,
      endodontics: api.is_endodontics || false,
      other: safeSplit(api.other_specialties)
    }
  };
};

export default deserializePractitioner;
